<template>
  <section class="hb-section" :class="{ 'hb-section--bordered': bordered, 'hb-section--flush': !padded }">
    <header v-if="title || $slots.actions || $slots.header" class="hb-section__head">
      <div class="hb-section__heading">
        <h3 v-if="title" class="hb-section__title">{{ title }}</h3>
        <div v-if="subtitle || $slots.subtitle" class="hb-section__subtitle">
          <slot name="subtitle">{{ subtitle }}</slot>
        </div>
        <slot name="header" />
      </div>
      <div v-if="$slots.actions" class="hb-section__actions">
        <slot name="actions" />
      </div>
    </header>

    <slot />
  </section>
</template>

<script>
/**
 * Casca de card do painel. Substitui o `vx-card` legado nas telas novas.
 *
 * Segue a especificacao do design system: branco, sem borda, raio .5rem, sombra unica,
 * padding 1.5rem, cabecalho em linha (titulo a esquerda, acoes a direita) e sem regua
 * divisoria. A variante `bordered` e para painel embutido: borda, sem sombra.
 */
export default {
  name: 'HbSection',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    /** Painel embutido: borda em vez de sombra. Card aninhado nao acumula elevacao. */
    bordered: { type: Boolean, default: false },
    padded: { type: Boolean, default: true },
  },
}
</script>

<style scoped>
.hb-section {
  background: var(--surface-card);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
  padding: clamp(1rem, 1.8vw, 1.5rem);
}

.hb-section--bordered {
  border: 1px solid var(--border-color);
  box-shadow: none;
}

.hb-section--flush {
  padding: 0;
}

.hb-section__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.hb-section__heading {
  min-width: 0;
}

.hb-section__title {
  margin: 0;
  font-size: var(--fs-card-title);
  font-weight: var(--fw-medium);
  color: var(--text-heading);
}

.hb-section__subtitle {
  margin-top: 0.3rem;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}

.hb-section__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}
</style>
